import { httpClient } from './http-client';
export const getCalculatePrice = async (data, signal) => httpClient.post('/api/payment/calculate-price/v2', [data], { signal });
